import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { config } from "@/config";
import { useAppDispatch, useAppState } from "@/store/useApp";
import { ClassificationType } from "@/types/config";
import { Settings2 } from "lucide-react";
import { useState } from "react";

export const ClassificationFilterDialog = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const classificationFilters = useAppState(
    (state) => state.classificationFilters ?? []
  );

  const toggleFilter = (code: ClassificationType) => {
    const newFilters = classificationFilters.includes(code)
      ? classificationFilters.filter((c: string) => c !== code)
      : [...classificationFilters, code];

    dispatch({ type: "SET_CLASSIFICATION_FILTERS", payload: newFilters });
  };

  return (
    <>
      <Button variant="ghost" size="icon" onClick={() => setOpen(true)}>
        <Settings2 className="h-5 w-5" />
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>AI Preferences</DialogTitle>
            <DialogDescription>
              Select which types of AI suggestions to show.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4">
            {Object.entries(config.classifications).map(
              ([code, classification]) => (
                <div key={code} className="flex items-start space-x-2">
                  <Checkbox
                    id={code}
                    checked={classificationFilters.includes(code as ClassificationType)}
                    onCheckedChange={() =>
                      toggleFilter(code as ClassificationType)
                    }
                  />
                  <div className="flex flex-col">
                    <label
                      htmlFor={code}
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      {classification.label}
                    </label>
                    <p className="text-sm text-muted-foreground">
                      {classification.description}
                    </p>
                  </div>
                </div>
              )
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
